import clsx from 'clsx'
import JsBarcode from 'jsbarcode'
import React, {memo, useEffect, useState} from 'react'

import * as classes from './BarcodeSvg.classes'

type Props = {
  text: string
  vertical?: boolean
}

function BarcodeSvgBase({text, vertical}: Props): React.ReactElement<Props> {
  // через state, потому что нужно как можно быстрее высчитать высоту получившегося
  // блока после поворота transform: rotate(...). useRef вызывает моргания интерфейса
  const [ref, setRef] = useState<SVGSVGElement | null>(null)

  useEffect(() => {
    if (ref) {
      // иногда строка которую кормим jsbarcode невалидна
      // ошибка не ловится, всплывает в скоупе принта, это все вызывает
      // огромное количество повторных запросов с чанками, если отловить здесь то все ОК
      try {
        const theme = document.documentElement.getAttribute('data-theme')
        const isDark = theme === 'dark'

        JsBarcode(ref, text, {
          background: 'transparent',
          displayValue: false,
          height: 56,
          width: 2,
          margin: 0,
          lineColor: isDark ? '#E0DEDA' : '#000000',
        })
      } catch (err) {
        console.warn(err)
      }
    }
  }, [ref, text])

  return (
    <div
      className={clsx(classes.barcodeContainer, vertical && classes.verticalBarcode)}
      style={{height: vertical ? ref?.getBoundingClientRect().height : undefined}}
    >
      <svg className={classes.barcode} ref={setRef} />
    </div>
  )
}

export const BarcodeSvg = memo(BarcodeSvgBase)
